import { Box, Typography } from '@mui/material'
import theme from 'lib/theme'
import React from 'react'
import { Product } from 'types/model/product'

export const QuantityColumn = ({ product }: { product: Product }) => {
  return (
    <>
      <Box
        sx={{
          padding: theme.spacing(1),
          height: theme.spacing(9),
          display: 'flex',
          overflow: 'wrap',
        }}>
        {product.collectedProduct &&
        Object.keys(product.collectedProduct).length > 0 &&
        product.collectedProduct.quantity !== product.quantity ? (
          <>
            <Typography variant='body2'>
              {product.collectedProduct.quantity}
              &nbsp;
            </Typography>
            <Typography
              sx={{ textDecoration: 'line-through', lineHeight: 1.43 }}>
              &nbsp;
              {String(product.quantity)}&nbsp;
            </Typography>
          </>
        ) : (
          <Typography>{product.quantity}</Typography>
        )}
      </Box>
      {product.pickingStatus.toLowerCase() === 'substituted' && (
        <Box
          sx={{
            height: theme.spacing(9),
            padding: theme.spacing(1),
          }}>
          <Typography>{product.quantity}</Typography>
        </Box>
      )}
    </>
  )
}
